module.exports = __webpack_public_path__ + "static/media/jar-left.29f59a2b.png";